import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ProblemService} from '../shared/problem.service';
import { ParamsService } from '../../../shared/params.service';
import { ProblemMultipleChoiceContainerComponent} from './problem-mc-container/problem-multiple-choice-container.component';

@Component({
    selector: 'app-exercise-problem',
    templateUrl: './exercise-problem.component.html',
    styleUrls: ['./exercise-problem.component.scss'],
    providers: [ProblemService],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ProblemMultipleChoiceContainerComponent]
})
export class ExerciseProblemComponent implements OnInit {

  public hintCollapsed = true;
  lessonId: number;
  discardedOptions: string[];
  // Current problem time spent
  problemTimeSpent: number;
  isPersistence = false;

  hint: string;

  @ViewChild(ProblemMultipleChoiceContainerComponent, { static: true })
  private problemMCContainer: ProblemMultipleChoiceContainerComponent;

  readyToContinue = false;

  getHintEnable = true;
  cutIncorrectEnable = true;
  stopTimerEnable = true;

  constructor(private router: Router,
              private activatedRoute: ActivatedRoute,
              private problemService: ProblemService,
              private paramsService: ParamsService) {
  }

  ngOnInit() {
    this.isPersistence = !!this.paramsService.getRouteDataById('persistence',
      this.activatedRoute.snapshot);
  }
}
